import * as React from "react";

import ListItem from "@mui/material/ListItem";

import { NavLink } from "react-router-dom";

export const NavItemLink = React.forwardRef((props: any, ref: any) => {
  const filteredProps = {
    ...props,
  };
  delete filteredProps.regularLink;
  return <NavLink exact={true} {...filteredProps} innerRef={ref} />;
});

// Can be a link, or button
export const NavItemComponent = React.forwardRef((props: any, ref: any) => {
  const { ...newProps } = props;

  // console.log(props);

  const component = props.regularLink ? (
    <ListItem {...newProps} button={true} component={"a"} href={props.link} target="_blank" />
  ) : typeof props.link === "string" ? (
    <ListItem {...newProps} button={true} component={NavItemLink} to={props.link} />
  ) : (
    <ListItem {...newProps} button={true} />
  );

  return <div ref={ref}>{component}</div>;
});

export default NavItemComponent;
